import React from 'react';
import { motion } from 'framer-motion';
import { Mountain, Thermometer, Handshake } from 'lucide-react';
const expertise = [{
  icon: Mountain,
  title: 'Site & Grade Mastery.',
  description: 'From rocky basalt ridges to riverfront slopes, we engineer foundations that embrace the Post Falls topography.'
}, {
  icon: Thermometer,
  title: 'Four-Season Performance.',
  description: 'High-efficiency insulation and structural integrity designed to handle Northern winters and summer heat.'
}, {
  icon: Handshake,
  title: 'Transparent Partnership.',
  description: 'No hidden costs. Just clear communication and a shared vision from ground-break to key-turn.'
}];
export function LocalExpertise() {
  return <section className="relative py-24 md:py-32 bg-[#F5F3F0] overflow-hidden" data-id="element-193">
      {/* Subtle stone texture */}
      <div className="absolute inset-0 texture-stone opacity-50" data-id="element-194" />

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-1/3 h-full bg-gradient-to-r from-[#E8E4DF]/50 to-transparent" data-id="element-195" />
      <div className="absolute bottom-0 right-0 w-64 h-64 border-2 border-[#A07656]/10 rounded-full translate-x-1/2 translate-y-1/2" data-id="element-196" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20" data-id="element-198">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[#A07656] uppercase tracking-[0.3em] text-xs font-semibold mb-4 block" data-id="element-199">
            Why Iron Ridge Custom Homes
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#1A1A1A]" data-id="element-200">
            Built for Our Terrain.
          </motion.h2>
        </div>

        {/* 3-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-201">
          {expertise.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="relative group" data-id="element-202">
              {/* Card */}
              <div className="relative bg-white p-8 lg:p-10 border-2 border-[#E8E4DF] h-full" data-id="element-203">
                {/* Accent corner */}
                <div className="absolute top-0 left-0 w-12 h-12 border-t-2 border-l-2 border-[#A07656] -translate-x-[2px] -translate-y-[2px]" data-id="element-204" />

                {/* Icon */}
                <div className="mb-8" data-id="element-205">
                  <div className="w-16 h-16 bg-[#1A1A1A] flex items-center justify-center" data-id="element-206">
                    <item.icon className="w-7 h-7 text-[#A07656]" strokeWidth={1.5} data-id="element-207" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4 leading-tight" data-id="element-208">
                  {item.title}
                </h3>
                <p className="text-[#595959] leading-relaxed" data-id="element-209">
                  {item.description}
                </p>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-8 right-8 h-[2px] bg-[#E8E4DF] group-hover:bg-[#A07656] transition-colors duration-500" data-id="element-210" />
              </div>
            </motion.div>)}
        </div>

        {/* Bottom decorative element */}
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} whileInView={{
        opacity: 1,
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mt-16 md:mt-20 flex items-center justify-center gap-4" data-id="element-211">
          <div className="h-[2px] w-16 bg-[#A07656]/30" data-id="element-212" />
          <div className="w-2 h-2 rounded-full bg-[#A07656]" data-id="element-213" />
          <div className="h-[2px] w-16 bg-[#A07656]/30" data-id="element-214" />
        </motion.div>
      </div>
    </section>;
}